module.exports = __webpack_public_path__ + "img/operacao-med.5b569d18.jpg";